import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { PhotoGalleryCarousel } from './PhotoCarousel'
import { PhotoCarouselPreview } from './PhotoCarouselPreview'

export const clickType = {
  FORWARD: 'forward',
  BACK: 'back'
}

const MAX_PHOTOS_AMOUNT = 25

export const PhotoCarousel = ({ listingId, listingType, firstPhoto, getCardPhotos, isEagerLoad}) => {
  const [isLoading, setLoading] = useState(false)
  const [initialIndex, setInitialIndex] = useState(1)
  const [photos, setPhotos] = useState([])

  const handleClick = async type => {
    setLoading(true)
    const responsePhotos = await getCardPhotos(listingType, listingId, { size: MAX_PHOTOS_AMOUNT })

    if (responsePhotos.length === 0) {
      setLoading(false)
    }

    setInitialIndex(type === clickType.FORWARD ? 1 : responsePhotos.length - 1)
    setPhotos(responsePhotos)
  }

  return (
    photos.length > 0 ? (
      <PhotoGalleryCarousel photos={photos} initialIndex={initialIndex} setLoading={setLoading} />
    ) : (
      <PhotoCarouselPreview isLoading={isLoading} photo={firstPhoto} onClick={handleClick} isEagerLoad={isEagerLoad} />
    )
  )
}

PhotoCarousel.propTypes = {
  firstPhoto: PropTypes.shape({
    id: PropTypes.number.isRequired,
    webp: PropTypes.string.isRequired,
    jpeg: PropTypes.string.isRequired
  }),
  listingId: PropTypes.number,
  listingType: PropTypes.string.isRequired,
  getCardPhotos: PropTypes.func,
  isEagerLoad: PropTypes.bool
}
